import { Component, OnInit, signal } from '@angular/core';
import { Router } from '@angular/router';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { SalesService } from '../../services/sales.service';
import { CommonModule } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { CabinetService } from '../../services/cabinet.service';

@Component({
  selector: 'app-sales-report',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './sales-report.component.html', 
  styleUrls: ['./sales-report.component.scss', '../../../app.component.scss']
})

export class SalesReportComponent implements OnInit{

  public period: any[] = [
    { period: "Last Month", monthlyInterval: "1" },
    { period: "Last Year", monthlyInterval: "12" },
    { period: "Last 3 Months", monthlyInterval: "2" },
    { period: "Last 6 Months", monthlyInterval: "3" },
  ];

  public detailType: string = '';
  // public period:any= [];
  public storeDetails : any = []
  public store_Id: string = "";
  public type: string = "";
  public stockId: string = "";
  public month_interval: string = "";
  public stockNames: any;
  public storeNames: any;
 
  public changedStoreName: string;
  changedStorePeriod: string = ''; 
  public currentStoreId: string;
  cabinet: any;

  constructor(public salesService: SalesService,public cabinetService: CabinetService,private route: ActivatedRoute,public dialog: MatDialog, private router: Router) { }

  isDropDown = signal(false);
  isDropDownPeriod = signal(false);

  ngOnInit() {
    this.getStoreCabinets()
    const selectedPeriod = this.period.find(period => period.period === this.changedStorePeriod);
  if (selectedPeriod) {
    this.month_interval = selectedPeriod.monthlyInterval;
  }
  }

  onStoreNameChange(id: string, name: string) {
    this.currentStoreId = id;
    this.changedStoreName = name;
    this.isDropDown.set(false);
    if (this.currentStoreId) { 
      this.getStoreDetails(this.month_interval); 
    }
  }
  
  onStorePeriodChange(period: any) {
    this.changedStorePeriod = period.period;
    this.month_interval = period.monthlyInterval; 
    this.isDropDownPeriod.set(false);
    if (this.currentStoreId) {
      this.getStoreDetails(this.month_interval);
    }
  }

  onStoreName(id: string, name: string){
    this.currentStoreId = id;
    this.changedStorePeriod = name;
    this.isDropDownPeriod.set(false);
    if (this.currentStoreId) { 
      const selectedPeriod = this.period.find(period => period.period === this.changedStorePeriod);
      if (selectedPeriod) {
        const monthlyInterval = selectedPeriod.month_interval;
        if (monthlyInterval !== undefined) {
          this.getStoreDetails(monthlyInterval);
        } else {
          console.error('Monthly interval is undefined');
        }
      } else {
        console.error('Selected period not found');
      }
    }
  }

  getStoreCabinets() {
    this.cabinetService.getStoreNames().subscribe(res => {
      this.storeNames = res.data;
      if (this.storeNames && this.storeNames.length > 0) {
        this.changedStoreName = this.storeNames[0].name;
        this.currentStoreId = this.storeNames[0].id;
        this.changedStorePeriod = this.period[0].period;
        this.getStoreDetails(this.period[0].monthlyInterval);
      }
    });
  }

  downloadSalesRecords(type: string, storeId: string){
    if (storeId && type) {
      this.salesService.downloadSalesRecords(type, storeId).subscribe((res) => {
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(res);
        link.download = `${type}`;
        link.click(); 
      });
    } else {
      console.error('StoreId or type is undefined or null');
    }
  }

  getStoreDetails(month_interval: string) {
    this.salesService.getStoreDetails(this.currentStoreId, month_interval).subscribe((res: any) => {
      if (res.success && res.data) {
        this.storeDetails = res.data;
      }
    });
  }

  navigateToDetailPage(storeId: string, type: string, productName: string, changedStorePeriod: string): void {
    const selectedPeriod = this.period.find(period => period.period === this.changedStorePeriod);
    if (storeId && type && selectedPeriod && selectedPeriod.monthlyInterval) {
      const monthInterval = selectedPeriod.monthlyInterval;
      this.router.navigate(['/home/sales/detail', type, storeId], { queryParams: { month_interval: monthInterval, product_name: productName, changedStore_Period: changedStorePeriod } });
    } else {
      console.error('StoreId, type, or monthInterval is undefined or null');
    }  
  }

  navigateToReportPage(){
    this.router.navigate(['/home/sales/report']);
  } 

  
  

  
  
}



// end point - 54.73.58.228:100/api/v1/reports/stores/:type
// types - sales_order, consumed, expired, missing, users

// query - month_interval, year_interval, store_id, from, to, download, page